<template>
  <div class="dialog-wrap">
    <el-dialog title="用户信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="close()"
               @open="open()"
               width="450px">
      <div class="senioBox">
        <div class="seniorItem">
          <div class="invite">
            <span class="blue"></span>
            <p>基础信息</p>
          </div>
          <el-form ref="userForm"
                   label-width="63px"
                   class="userForm"
                   style="marginLeft:-30px;">
            <el-form-item label="用户ID">
              <el-input v-model="senior.id"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="头像">
              <el-avatar :src="senior.avatar"
                         disabled></el-avatar>
            </el-form-item>

            <el-form-item label="昵称">
              <el-input v-model="senior.nickname"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="senior.gender"
                              disabled>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
                <el-radio :label="0">未知</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="身份">
              <div v-if="senior.senior_id">
                <el-tag v-if="senior.gender==1"
                        type="success">学长</el-tag>
                <el-tag v-if="senior.gender==2"
                        type="success">学姐</el-tag>
              </div>
              <el-tag v-if="!senior.senior_id">学员</el-tag>
            </el-form-item>

            <el-form-item label="个人简介"
                          v-if="senior.additional">
              <el-input v-model="senior.additional"
                        disabled
                        type="textarea"></el-input>
            </el-form-item>
          </el-form>

          <el-form ref="userForm"
                   label-width="63px"
                   class="userForm"
                   style="marginLeft:-30px;">
            <div class="invite"
                 style="marginLeft:10px;marginBottom:20px">
              <span class="blue"></span>
              <p>联系方式</p>
            </div>

            <el-form-item label="手机号">
              <el-input v-model="senior.mobile"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="微信号">
              <el-input v-model="senior.wechat"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="QQ号">
              <el-input v-model="senior.qq"
                        disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { memberOne } from '@/api/member'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: () => {
        return null
      },
    },
    editFlag: {
      type: Boolean,
      default: () => {
        return true
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      senior: {},
      filter: {
        year: [
          {
            label: '2024年',
            value: '2024',
          },
          {
            label: '2023年',
            value: '2023',
          },
          {
            label: '2022年',
            value: '2022',
          },
          {
            label: '2021年',
            value: '2021',
          },
          {
            label: '2020年',
            value: '2020',
          },
        ],
      },
      majorList: [],
      academyList: [],
      directionList: [],
      subjectsList: [],
      scoreList: [],
      honor: ['初试第一', '专业课第一', '总分第一'],
      otherHonor: [],
      disabled: true,
      userMess: { test_subject_codes: [] },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    open() {
      this.getDetail()
    },

    getDetail() {
      memberOne({ id: this.rowId }).then((res) => {
        this.senior = res
      })
    },
  },
}
</script>

<style lang="less" scoped>
/* 穿透 scoped 样式，修改输入框边框 */
::v-deep .inptScore .el-input__inner {
  border: none; /* 去掉默认边框 */
  box-shadow: none; /* 去掉聚焦时的阴影（可选，根据需求） */
}
::v-deep .el-form-item--small .el-form-item__label {
  font-size: 12px;
}

/* 去掉聚焦状态的边框（避免点击后出现边框） */
::v-deep .inptScore .el-input__inner:focus {
  border: none;
  box-shadow: none;
}
.dialog-wrap {
  ::v-deep .el-dialog__header {
    background: #ecf2fe;
  }
  .senioBox {
    padding-left: 10px;
    display: flex;
    .footer {
      display: flex;
      justify-content: flex-end;
      .cancle {
        text-align: center;
        font-size: 14px;
        width: 56px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
        margin-right: 10px;
      }
      .confirm {
        text-align: center;
        width: 56px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;
        color: #fff;
        background: #1f86fe;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .seniorItem {
      margin-left: 10px;
      position: relative;
      width: 400px;

      .invite {
        margin-left: -10px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 14px;
        color: #303133;

        .blue {
          margin-right: 6px;
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
      }
      .edit {
        cursor: pointer;
        position: absolute;
        right: 30px;
        top: -10px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #409eff;
        width: 56px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #409eff;
      }
      .userForm {
        width: 350px;
        margin-top: 14px;
      }
      .score {
        width: 180px;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #dddddd;
        margin-top: 10px;
        display: flex;
        height: 35px;
        position: relative;
        .preScore {
          font-size: 12px;
          position: absolute;
          right: 5px;
        }

        .subjectName {
          min-width: 100px;
          height: 35px;
          padding-left: 6px;
          padding-right: 6px;
          line-height: 35px;
          font-size: 10px;
          display: inline-block;
          background: #eeeeee;
          border-radius: 1px 0px 0px 1px;
        }
      }
    }
  }
  .submit {
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    .cancle {
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 18px;
    }
    .confirm {
      width: 56px;
      height: 36px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>
